import { Schema } from "effect";
import { WorkspaceId } from "@workerstation/shared/development-identifiers";
import { WorkspaceHistoryRevision } from "@workerstation/shared/history/workspace";
export type { HistoryClientFailure } from "../history/model.ts";
export const WorkspaceBaseline = Schema.Struct({
  workspaceId: WorkspaceId, files: Schema.Record(Schema.String, Schema.String),
  revision: Schema.NullOr(WorkspaceHistoryRevision)
});
export type WorkspaceBaseline = typeof WorkspaceBaseline.Type;
